<button
    mat-flat-button
    [type]="type"
    class="w-auto rounded-md"
    [ngClass]="[colorClass, clases]"
    [style.border-color]="colorStyle"
    [style.color]="textColorStyle"
    [style.background-color]="clases.includes('bg-') ? '' : colorStyle"
    [disabled]="disabled || loading"
    (click)="manejarClick()"
>
    <span class="flex gap-2 items-center">
        <mat-spinner
            *ngIf="loading"
            class="boton-dinamico-spinner"
            [diameter]="18"
        ></mat-spinner>

        <ng-container *ngIf="!loading">
            <mat-icon
                *ngIf="icono && iconoPosicion === 'izquierda'"
                [ngClass]="classIcon"
                [svgIcon]="icono"
            ></mat-icon>
            <mat-icon
                *ngIf="fontIcon && !icono && iconoPosicion === 'izquierda'"
                [ngClass]="classIcon"
            >{{ fontIcon }}</mat-icon>
        </ng-container>

        <span *ngIf="texto" [ngClass]="{'hidden sm:inline': hideTextMobile}" class="font-normal">{{ texto }}</span>

        <ng-container *ngIf="!loading">
            <mat-icon
                *ngIf="icono && iconoPosicion === 'derecha'"
                [ngClass]="classIcon"
                [svgIcon]="icono"
            ></mat-icon>
            <mat-icon
                *ngIf="fontIcon && !icono && iconoPosicion === 'derecha'"
                [ngClass]="classIcon"
            >{{ fontIcon }}</mat-icon>
        </ng-container>
    </span>
</button>
